import { logDispatcher } from 'src/app/core/decorators/state.decorators';
import { ScholarshipType, ScholarshipTypeMap } from '../../models/scholarship-type.model';

export namespace ScholarshipTypeActions {
  @logDispatcher
  export class GetScholarships {
    static readonly type = '[ScholarshipTypes] GetScholarships';
    constructor(public zoneId: number) {}
  }

  @logDispatcher
  export class GetScholarshipsSuccess {
    static readonly type = '[ScholarshipTypes] GetScholarshipsSuccess';
    constructor(public scholarshipTypes: ScholarshipType[]) {}
  }

  @logDispatcher
  export class GetScholarshipsFail {
    static readonly type = '[ScholarshipTypes] GetScholarshipsFail';
    constructor(public error: any) {}
  }

  @logDispatcher
  export class GetScholarshipTypes {
    static readonly type = '[ScholarshipTypes] GetScholarshipTypes';
    constructor() {}
  }

  @logDispatcher
  export class GetScholarshipTypesSuccess {
    static readonly type = '[ScholarshipTypes] GetScholarshipTypesSuccess';
    constructor(public scholarshipTypesMap: ScholarshipTypeMap[]) {}
  }

  @logDispatcher
  export class GetScholarshipTypesFail {
    static readonly type = '[ScholarshipTypes] GetScholarshipTypesFail';
    constructor(public error: any) {}
  }
}
